/// <amd-module name="TFS/Admin/Common/Constants/Generated/Constants" />
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.TeamFoundation.Framework.Server
//----------------------------------------------------------


export module PolicyNames {
    export const Namespace = "TenantPolicy";
    export const OrganizationCreationRestriction = "TenantPolicy.OrganizationCreationRestriction";
    export const RestrictGlobalPersonalAccessToken = "TenantPolicy.RestrictGlobalPersonalAccessToken";
    export const RestrictFullScopePersonalAccessToken = "TenantPolicy.RestrictFullScopePersonalAccessToken";
    export const RestrictPersonalAccessTokenLifespan = "TenantPolicy.RestrictPersonalAccessTokenLifespan";
    export const EnableLeakedPersonalAccessTokenAutoRevocation = "TenantPolicy.EnableLeakedPersonalAccessTokenAutoRevocation";
}

export module PolicyProperties {
    export const AllowedUsersAndGroupObjectIds = "AllowedUsersAndGroupObjectIds";
    export const MaxPatLifespanInDays = "MaxPatLifespanInDays";
    export const ErrorMessage = "ErrorMessage";
}

